import { routerReducer, LOCATION_CHANGE } from "react-router-redux";
const INITIAL_STATE = {
    previousLocation: null
};
export default function routingReducer(previousState, action) {
    const maybeNextState = routerReducer(previousState, action);
    const nextState = "previousLocation" in maybeNextState ? maybeNextState : {
        ...(previousState || INITIAL_STATE),
        ...maybeNextState
    };
    if (action.type === LOCATION_CHANGE) {
        return {
            ...nextState,
            previousLocation: previousState.locationBeforeTransitions
        };
    }
    return nextState;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/routing/routingReducer.ts